
import Vue from "vue";
export default Vue.extend({
	props: {
		grow: Boolean
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
